const GM8Tag = () => {
  return (
    <div className="tag gm8">
      <span className="tagText">GameMaker 8.0</span>
    </div>
  );
};

export default GM8Tag;
